import base64 from 'base-64'
import utf8 from 'utf8'

const encode = value => base64.encode(utf8.encode(value))
const decode = value => utf8.decode(base64.decode(value))

const keyMain = encode('mpMainRegion-v2')
const keyFavorite = encode('mpFavoriteRegionList-v2')

/**
 * @returns {Region}
 */
export const getMainRegion = () => {
  let city = localStorage.getItem(keyMain)

  if (city) {
    city = JSON.parse(decode(city))
  }

  // @ts-ignore
  return city || null
}

/**
 * @param {Region} city
 */
export const setMainRegion = (city) => {
  if (city === null) { return }

  const cityJson = JSON.stringify(city)
  const cityEncode = encode(cityJson)

  localStorage.setItem(keyMain, cityEncode)
}

/**
 * @returns {Region[]}
 */
export const getFavoriteRegionList = () => {
  let cityList = localStorage.getItem(keyFavorite)

  if (cityList) {
    cityList = JSON.parse(decode(cityList))
  }

  // @ts-ignore
  return cityList || null
}

/**
 * @param {Region} city
 */
export const addFavoriteRegion = (city) => {
  if (city === null) { return }

  const cityList = getFavoriteRegionList() || []

  const cleanList = cityList.filter(item => item.id !== city.id)
  cleanList.unshift(city)

  const cityListJson = JSON.stringify(cleanList)
  const cityListEncode = encode(cityListJson)


  localStorage.setItem(keyFavorite, cityListEncode)
}

/**
 * @param {string} id
 */
export const deleteFavoriteRegion = (id) => {
  if (id === null) { return }

  const cityList = getFavoriteRegionList() || []

  const cleanList = cityList.filter(item => item.id !== id)

  const cityListJson = JSON.stringify(cleanList)
  const cityListEncode = encode(cityListJson)

  localStorage.setItem(keyFavorite, cityListEncode)
}

export default {
  getMainRegion,
  setMainRegion,
  getFavoriteRegionList,
  addFavoriteRegion,
  deleteFavoriteRegion,
}